<!-- @prettier -->
<template>
  <div>
    <Hero title="Nutzungsbedingungen" />
    <section class="container content">
      <div class="breadcrumb d-flex">
        <div class="flex-grow-1">
          <nuxt-link :to="localePath('/')">Home</nuxt-link>
          <span class="breadcrumb--separator">></span>
          {{ $t('AGB') }}
        </div>
      </div>

      <h2>{{ $t('Nutzungsbedingungen') | capitalize }} ({{ $t('AGB') }})</h2>

      <agbFr v-if="$i18n.locale == 'fr'" />
      <div v-else>
        <p>Version 1.0 zuletzt aktualisiert am 29. April 2020</p>

        <h2>Generelles</h2>

        <p>
          Die jeweils aktuellste Version der AGB ist unter
          <nuxt-link to="/agb">https://lernpfad.ch/agb</nuxt-link>
          einsehbar. Lernpfad.ch stellt unter lernpfad.ch Produkte, Software und
          Dienstleistungen (im Folgenden zusammenfassend «Dienste») zur
          Verfügung. Durch die Nutzung dieser Dienste erklärst du dich mit den
          vorliegenden Allgemeinen Geschäftsbedingungen (im Folgenden «AGB»)
          einverstanden. Auf Grund der Weiterentwicklung der Dienste behält sich
          Lernpfad.ch das Recht vor, die AGB jederzeit und ohne Vorankündigung
          anzupassen. Wenn der Kunde mit den geänderten AGBs nicht einverstanden
          ist, muss das Konto innert 30 Tagen aufgehoben werden.
        </p>

        <h2>Datenschutz</h2>
        <p>
          Unsere Grundhaltung basiert auf drei Prinzipien: Wir sammeln so wenig
          Daten wie möglich (Datensparsamkeit), wenn immer möglich werden die
          Daten auf unseren Servern gespeichert (Datenaustausch) und wir geben
          unser Bestes, damit deine Daten sicher sind (Datensicherheit)!
        </p>
        <p>
          Du erreichst unseren Datenschutzbeauftragten unter
          <a href="mailto:datenschutz@lernpfad.ch">datenschutz@lernpfad.ch</a>
          Alle weiteren Informationen findest du unter
          <nuxt-link
            :to="localePath('/datenschutz')"
            target="_blank"
          >
            https://lernpfad.ch/datenschutz
          </nuxt-link>
          .
        </p>

        <h2>Leistungserbringung</h2>

        <p>
          Lernpfad.ch übernimmt keine Gewährleistung dafür, dass die angebotenen
          Dienste deinen Anforderungen oder Erwartungen entsprechen, das Angebot
          ununterbrochen, zeitgerecht, sicher und fehlerfrei zur Verfügung
          steht, die durch die Benutzung der Dienste erhaltenen Informationen
          oder Inhalte korrekt und zuverlässig sind oder allfällige Fehler in
          den Diensten korrigiert werden.
        </p>

        <p>
          Lernpfad.ch haftet nicht für direkte oder indirekte Schäden
          irgendwelcher Art, die durch die Nutzung bzw. das Unvermögen zur
          Nutzung, Änderungen, dauerhafte und vorübergehende Nichtverfügbarkeit
          der Dienste oder andere Ursachen im Zusammenhang mit den Diensten
          verursacht werden.
        </p>

        <p>
          Lernpfad.ch leistet technischen Support auf «Best Effort»-Basis und
          ausschliesslich via
          <a href="mailto:info@lernpfad.ch">E-Mail</a>
          .
        </p>

        <p>
          Lernpfad.ch hat das Recht, sich für die Leistungserbringung jederzeit
          und in beliebigem Umfang den Diensten Dritter zu bedienen. Unter
          <nuxt-link
            :to="localePath('/datenschutz')"
            target="_blank"
          >
            https://lernpfad.ch/datenschutz
          </nuxt-link>
          werden diese alle aufgeführt.
        </p>

        <p>
          Lernpfad.ch wird ständig weiterentwickelt, deshalb können Teile von
          Lernpfad.ch jederzeit abgeändert oder entfernt werden. Unvorhersehbare
          Gründe können dazu führen, dass der Dienst dauerhaft oder
          vorübergehend eingestellt wird. Wir setzen aber alles daran,
          Lernpfad.ch in einer kostenlosen Basis-Version möglichst lange zur
          Verfügung zu stellen.
        </p>

        <h2>Nutzung von Lernpfad.ch</h2>

        <p>
          Die Registrierung auf lernpfad.ch erfolgt kostenlos. Ein Anspruch auf
          Zulassung zur Applikation besteht nicht. Bei der Nutzung gilt es
          folgende Punkte zu beachten:
        </p>

        <ul>
          <li>
            Du bist selber verantwortlich für die Sicherheit deines Passworts.
          </li>
          <li>
            Du bist verpflichtet, alle im Rahmen einer Registrierung nötigen
            Informationen korrekt und wahrheitsgemäss auszufüllen und aktuell zu
            halten.
          </li>
          <li>Es ist nicht zulässig, Konten automatisiert zu erstellen.</li>
          <li>
            Du darfst dich auf Lernpfad.ch nicht als eine andere Person ausgeben
            um andere Leute zu täuschen.
          </li>
          <li>Diskriminierung jeglicher Art sind verboten.</li>
          <li>
            Du erklärst dich einverstanden, die Dienste nicht in irgendeiner
            Weise absichtlich zu stören oder zu unterbrechen.
          </li>
          <li>
            Du erklärst dich einverstanden, die Dienste zu keinem Zweck zu
            reproduzieren, zu kopieren, zu verkaufen, zu handeln oder weiter zu
            vertreiben.
          </li>
          <li>
            Lernpfad.ch behält sich vor (aber ist nicht dazu verpflichtet),
            Inhalte oder Konten innerhalb der Dienste zu prüfen, zu filtern, zu
            verändern, zurückzuweisen oder zu löschen um Missbrauch zu
            vermeiden. Falls ein Benutzerkonto gesperrt wird, macht Lernpfad.ch
            den Inhaber des Benutzerkontos via E-Mail auf die Sperrung
            aufmerksam.
          </li>
        </ul>

        <h2>Veröffentlichung von Lernpfaden und Urheberrecht</h2>

        <p>
          Mit dem Erstellen eines Lernpfades erklärt sich der/die Autor/in
          bereit und berechtigt, diese Inhalte auf lernpfad.ch zu
          veröffentlichen. Es gehen keine Urheberrechte auf die
          Betreibergesellschaft Lernpfad.ch über. Der/die Autor/in ist dafür
          verantwortlich, dass keine Urheberrechte Dritter verletzt werden und
          haftet alleine dafür. Lernpfad.ch haftet nicht für den Inhalt von
          Websites Dritter, auf die mittels Hyperlinks verwiesen wird.
        </p>

        <p>
          Alle erstellten Lernpfade werden von den Betreibern nur formell
          editiert. Sie stellen ausschliesslich die persönliche Meinung der
          Autorin beziehungsweise des Autors dar. Für deren Richtigkeit wird
          keine Haftung übernommen.
        </p>

        <p>
          Lernpfad.ch bietet die Möglichkeit, Urheberrechtsverletzungen unter
          <a href="mailto:info@lernpfad.ch">info@lernpfad.ch</a>
          zu melden.
        </p>

        <p>
          Lernpfad.ch als Betreiberin behält sich vor, Einträge ohne spezielle
          Ankündigung zu löschen um Missbrauch entgegenzuwirken.
        </p>

        <p>
          Die Informationen sind ohne Rücksprache mit den Berechtigten
          ausschliesslich für den Eigengebrauch im Rahmen der
          Unterrichtstätigkeit zu verwenden.
        </p>

        <p>
          Der/die Autor/in eines Lernpfades muss beim Teilen eines Lernpfades
          selber dafür besorgt sein, dass keine Urheberrechte Dritter verletzt
          werden.
        </p>

        <p>
          Lernpfad.ch wird keine Lizenzgebühren für Urheberrechtsverletzungen
          begleichen.
        </p>

        <h2>Abwehrklausel</h2>

        <p>
          Die vorliegenden AGB werden im Rahmen des Registrierungsprozesses
          akzeptiert und als anwendbar erklärt. Sie gelten ausschliesslich und
          auf unbestimmte Zeit, solange sie nicht durch Vereinbarung geändert
          oder ersetzt werden.
        </p>

        <h2>Salvatorische Klausel</h2>

        <p>
          Sollten sich Teile dieser AGB aus irgendeinem Grund als nicht
          durchsetzbar oder ungültig erweisen, wird dadurch die Gültigkeit der
          übrigen Bestimmungen nicht berührt. Anstelle der unwirksamen
          Bestimmung gilt eine Bestimmung als von Anfang an wirksam vereinbart,
          die der von den Vertragspartnern gewollten Bestimmung wirtschaftlich
          am nächsten kommt. Das Gleiche gilt im Falle einer Lücke.
        </p>

        <h2>Anwendbares Recht & Gerichtsstand</h2>
        <p>
          Es ist ausschliesslich Schweizerisches Recht anwendbar. Der
          Gerichtsstand ist Bern.
        </p>

        <p>
          Du erklärst dich einverstanden, die Dienste nur gemäss der
          vorliegenden Bestimmungen einzusetzen.
        </p>
      </div>
    </section>
  </div>
</template>

<script>
import Hero from '../components/ui/Hero'
import { ampli } from '../mixins/Amplitude/index.js'
import agbFr from '../components/locales/agb_fr.vue'

export default {
  nuxtI18n: {
    paths: {
      fr: '/cgv',
    },
  },

  components: {
    Hero,
    agbFr,
  },
  mixins: [ampli],

  scrollToTop: true,

  head() {
    return {
      title: this.$i18n.t('AGB | Lernpfad'),
    }
  },

  created() {
    ampli.agbPageViewed()
  },
}
</script>

<style
  scoped
  lang="scss"
>
@import '../assets/style/utils';

.content,
::v-deep .content {
  margin-top: 5em;

  h1 {
    word-wrap: break-word;
  }

  h2 {
    margin: 2rem 0 1rem 0;
    @include fontSizeLineHeight(35px, 66px);
  }

  p {
    margin-bottom: 0.5rem;
  }

  h1 {
    word-wrap: break-word;
  }

  h2 {
    margin: 2rem 0 1rem 0;
    @include fontSizeLineHeight(35px, 66px);
  }

  p {
    margin-bottom: 0.5rem;
  }
}
</style>
